module.exports = __webpack_public_path__ + "static/img-7d84c018c6450d8f599ba7b660c786e5.jpeg";